// extracted by mini-css-extract-plugin
export var dividerLine = "_53-0";
export var errorBackground = "_53-1";